var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConjuncion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M620,414l169.34-165.33,49.33,50.67-168,164c31.1,40.9,46.66,86.67,46.66,137.34,0,63.12-23.32,117.33-70,162.66-46.66,45.33-102.65,68-168,68s-121.32-22.67-167.99-68c-46.68-45.33-70-99.77-70-163.33s23.32-118,70-163.33c46.66-45.35,102.43-68,167.33-68,52.43,0,99.53,15.12,141.32,45.33ZM596.66,486.67c-32.45-31.54-71.55-47.33-117.33-47.33s-85.12,15.79-117.99,47.33c-32.91,31.56-49.33,69.34-49.33,113.33s16.42,81.79,49.33,113.33c32.86,31.56,72.2,47.33,117.99,47.33s84.88-15.77,117.33-47.33c32.44-31.54,48.68-69.34,48.68-113.33s-16.24-81.77-48.68-113.33Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConjuncion);
export default __webpack_public_path__ + "static/media/Conjuncion.4d22b325d2c0ba481572b4a15ab06ed4.svg";
export { ForwardRef as ReactComponent };